import {AlertaEnum} from '../Enumeraciones/MensajeEnumeraciones.enum';

export class AlertaModel
{
  public Remove: boolean = true;
  public Descripcion: string = "";
  public Tipo: AlertaEnum = AlertaEnum.Success;
  public AlertaId:number = 0;
  public Icono:string = "";
  public Clase : string = "";
  public Animacion : string = "slideInUp";
  public Tiempo : number = 0;

  constructor(init?:Partial<AlertaModel>)
  {
    Object.assign(this, init);
  }

}

